module.exports = __webpack_public_path__ + "static/media/mx.3aa223c8.svg";